import angular from 'angular';
import template from './mobile-patient-actions.html';
class GroupCallMobilePatientActionsController {
    constructor() { }
    $onInit() { }
}
const groupCallMobilePatientActions = {
    template,
    bindings: {
        onToggleAudio: '&',
        hasAudio: '&',
        activeVideoProvider: '<',
    },
    controller: GroupCallMobilePatientActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrame.selfVideoFrameFull.actions.groupCall.mobilePatientActions', [])
    // group-call-mobile-patient-actions
    .component('groupCallMobilePatientActions', groupCallMobilePatientActions)
    .name;
